import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import CustomInput from "@/pages/checkout/components/CustomInput/CustomInput";
import stl from "./ShopApplyForm.module.css";
import NDayGuarantee from "@/pages/checkout/components/NDayGuarantee/NDayGuarantee";
import MobileCarInfoV2 from "@/pages/checkout/components/HeadingSteps/MobileCarInfo/MobileCarInfoV2";
import { useLocation } from "react-router-dom";
import { CDN_LINK, serverUrl } from "@globalConfig";
import { cashCheckout3Event } from "@/utils/dataLayerEvents";
import Tag from "../../../../components/UiKit/Tag/Tag";
import { unbxdAnalytics } from "@/redux/actions/unbxdActions";
import { trackEvents } from "@/common/events/events";
import ChangeAccountVerificationModal from "@/_MiniApps/auth/ui/ChangeAccountVerificationModal/ChangeAccountVerificationModal";
import { useTranslation } from "@i18n";
import { useAuthActions, useSession } from "@/_MiniApps/auth/AuthContext";
import useButtonLoading from "@hooks/useButtonLoading";
import useApi from "@hooks/useApi";
import { api__getCitiesDropDown } from "@/apis/assets/api__get_cities_drop_down";
import InputPhoneNumber from "@componentsShared/InputPhoneNumber/InputPhoneNumber";
import useLocalStorage from "@hooks/useLocalStorage";
import useSubmissionSource from "@hooks/useSubmissionSource";
import { useCheckoutOrder } from "@/common/Contexts/CheckoutOrderContext";
import { toast } from "sonner";
import { ValidationException } from "@/common/exceptions/ValidationException";
import useIsMobile from "@hooks/useIsMobile";
import PromoTag from "@/_MiniApps/customized_promo_codes/components/PromoTag";
import { useEnhancedPromoSystem } from "@/_MiniApps/customized_promo_codes/hooks/useEnhancedPromoSystem";
import { checkFeatureFlag } from "@/common/config/websiteConfig";
import WarrantySection from "@/pages/checkout/warranty/WarrantySection";
import { useAbandonmentTracking } from "@/common/Contexts/AbandonmentTrackingContext";
import { REFERRER_REWARD_TYPE } from "@/pages/checkout/constants";
import useCookieClient from "@hooks/useCookieClient";
var showToast = function showToast(msg) {
  toast.success(msg, {
    position: "bottom-center",
    duration: 2000,
    style: {
      zIndex: 9999999
    }
  });
};
var showErrorToast = function showErrorToast(msg) {
  toast.error(msg, {
    position: "bottom-center",
    duration: 5000,
    style: {
      zIndex: 9999999
    }
  });
};
var ShopApplyForm = function ShopApplyForm(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useLocalStorage = useLocalStorage(),
    setLocalStorage = _useLocalStorage.setLocalStorage;
  var location = useLocation();
  var isMobile = useIsMobile();
  var _useState = useState({}),
    errors = _useState[0],
    setErrors = _useState[1];
  var _useState2 = useState(null),
    validationException = _useState2[0],
    setValidationException = _useState2[1];
  var _useState3 = useState(false),
    showVerificationModal = _useState3[0],
    setShowVerificationModal = _useState3[1];
  var _useState4 = useState(null),
    promoFromUrl = _useState4[0],
    setPromoFromUrl = _useState4[1];
  var _useState5 = useState(false),
    hasUserStartedCheckoutForm = _useState5[0],
    setHasUserStartedCheckoutForm = _useState5[1];
  var buttonLoading = useButtonLoading();
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn,
    user = _useSession.user;
  var _useCookieClient = useCookieClient(),
    getCookieClient = _useCookieClient.getCookieClient;
  var _useAuthActions = useAuthActions(),
    logout = _useAuthActions.logout;
  var _useCheckoutOrder$sta = useCheckoutOrder().state,
    checkoutOrder = _useCheckoutOrder$sta.checkoutOrder,
    formData = _useCheckoutOrder$sta.formData,
    referralData = _useCheckoutOrder$sta.referralData,
    fetching_error = _useCheckoutOrder$sta.fetching_error;
  var _useCheckoutOrder$que = useCheckoutOrder().queryParams,
    customerid = _useCheckoutOrder$que.customerid,
    referral = _useCheckoutOrder$que.referral,
    hasTawuniyaParams = _useCheckoutOrder$que.hasTawuniyaParams,
    post_id = _useCheckoutOrder$que.post_id;
  var _useCheckoutOrder$act = useCheckoutOrder().actions,
    setFormItem = _useCheckoutOrder$act.setFormItem,
    action__resetPromoCode = _useCheckoutOrder$act.action__resetPromoCode;
  var _useCheckoutOrder$rem = useCheckoutOrder().remote_actions,
    fetch__getOrderDetailsByParams = _useCheckoutOrder$rem.fetch__getOrderDetailsByParams,
    fetch__getPromoCode = _useCheckoutOrder$rem.fetch__getPromoCode,
    fetch__createOrder = _useCheckoutOrder$rem.fetch__createOrder;
  var _useAbandonmentTracki = useAbandonmentTracking(),
    startAbandonmentTracking = _useAbandonmentTracki.startAbandonmentTracking,
    completeAbandonmentTracking = _useAbandonmentTracki.completeAbandonmentTracking;
  var _useSubmissionSource = useSubmissionSource(),
    getSubmissionSource = _useSubmissionSource.getSubmissionSource;
  var _useApi = useApi([], api__getCitiesDropDown),
    _useApi2 = _slicedToArray(_useApi, 3),
    loadingCities = _useApi2[0],
    errorCities = _useApi2[1],
    cities = _useApi2[2];
  var _useEnhancedPromoSyst = useEnhancedPromoSystem(),
    promoCode = _useEnhancedPromoSyst.promoCode,
    getPromoEventParams = _useEnhancedPromoSyst.getPromoEventParams,
    displayConfig = _useEnhancedPromoSyst.displayConfig;
  var allPromoCodes = promoCode ? [promoCode] : [];
  useEffect(function () {
    var _props$setHasUserStar, _checkoutOrder$g4_dat, _checkoutOrder$g4_dat2;
    if (!post_id || !(checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.g4_data_layer)) return;
    if (!hasUserStartedCheckoutForm) return;
    (_props$setHasUserStar = props.setHasUserStartedCheckoutForm) === null || _props$setHasUserStar === void 0 ? void 0 : _props$setHasUserStar.call(props, true);
    completeAbandonmentTracking("add_to_cart_completed_cash_".concat(post_id));
    startAbandonmentTracking({
      key: "start_checkout_abandoned_cash_".concat(post_id),
      event: "start_checkout_abandoned",
      shouldTrack: true,
      payload: _objectSpread(_objectSpread({}, checkoutOrder.g4_data_layer), {}, {
        inventory_type: (_checkoutOrder$g4_dat = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat === void 0 ? void 0 : _checkoutOrder$g4_dat.inventory_type_string,
        post_trim: (_checkoutOrder$g4_dat2 = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat2 === void 0 ? void 0 : _checkoutOrder$g4_dat2.post_ext,
        booking_type: "cash",
        last_completed_step: ''
      })
    });
  }, [checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.g4_data_layer, completeAbandonmentTracking, hasUserStartedCheckoutForm, post_id, startAbandonmentTracking]);
  useEffect(function () {
    if (fetching_error) {
      showErrorToast(fetching_error.message);
    }
  }, [fetching_error]);
  var completeCashCheckoutAbandonmentTracking = function completeCashCheckoutAbandonmentTracking() {
    completeAbandonmentTracking("add_to_cart_completed_cash_".concat(post_id));
    completeAbandonmentTracking("start_checkout_abandoned_cash_".concat(post_id));
  };
  var setFormItemProxy = function setFormItemProxy(key, value) {
    // Update form data and clear existing error for this field
    setFormItem(key, value);
    setErrors(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, key, null));
    });
  };
  var validateFieldOnBlur = function validateFieldOnBlur(key, value) {
    var tempFormData = _objectSpread(_objectSpread({}, formData), {}, _defineProperty({}, key, value));
    var validationErrors = handleValidation(tempFormData);
    if (validationErrors && validationErrors[key]) {
      setErrors(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, key, validationErrors[key]));
      });
    } else {
      // Clear error if validation passes
      setErrors(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, key, null));
      });
    }
  };
  var getErrMsg = function getErrMsg(fieldName) {
    return (errors === null || errors === void 0 ? void 0 : errors[fieldName]) || (validationException === null || validationException === void 0 ? void 0 : validationException.extractErrorMessageFrom([fieldName]));
  };
  var handleValidation = function handleValidation() {
    var _currentFormData$full;
    var currentFormData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : formData;
    var clientSideErrors = {};
    if (!(currentFormData !== null && currentFormData !== void 0 && currentFormData.full_name)) {
      clientSideErrors["full_name"] = t("validation_name_filled", {
        ns: "web_checkout_cash"
      });
    } else if ((currentFormData === null || currentFormData === void 0 ? void 0 : (_currentFormData$full = currentFormData.full_name) === null || _currentFormData$full === void 0 ? void 0 : _currentFormData$full.trim().length) < 5) {
      clientSideErrors["full_name"] = t("validation_name_5_characters", {
        ns: "web_checkout_cash"
      });
    } else {
      // Add validation for special characters and unsupported characters
      var namePattern = /^[\u0600-\u06FFa-zA-Z\s]+$/; // Arabic and English letters and spaces only
      if (!namePattern.test(currentFormData.full_name.trim())) {
        clientSideErrors["full_name"] = t("validation_name_contain_symbols_unsupported_characters", {
          ns: "web_checkout_cash"
        });
      }
    }
    if (!(currentFormData !== null && currentFormData !== void 0 && currentFormData.city_id)) {
      clientSideErrors["city_id"] = t("validation_city_chosen", {
        ns: "web_checkout_cash"
      });
    }
    if (!(currentFormData !== null && currentFormData !== void 0 && currentFormData.phone_number)) {
      clientSideErrors["phone_number"] = t("validation_mobile_number_chosen", {
        ns: "web_checkout_cash"
      });
    } else {
      if (!/^(05)[0-9]{8}$/.test(currentFormData === null || currentFormData === void 0 ? void 0 : currentFormData.phone_number)) {
        clientSideErrors["phone_number"] = t("validation_mobile_number_consist_ten_numbers", {
          ns: "web_checkout_cash"
        });
      }
    }
    return Object.keys(clientSideErrors).length > 0 ? clientSideErrors : null;
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
      var clientSideErrors, unbxdParams, _checkoutOrder$g4_dat3, response, hasValidationErrors, hasError, backendErrors, errorMessages, freshOrder, submission_source, promoCodedata, formValidationException, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            e === null || e === void 0 ? void 0 : e.preventDefault();
            clientSideErrors = handleValidation();
            if (!clientSideErrors) {
              _context.n = 1;
              break;
            }
            return _context.a(2, setErrors(function (pre) {
              return _objectSpread(_objectSpread({}, pre), clientSideErrors);
            }));
          case 1:
            if (!(isLoggedIn && (user === null || user === void 0 ? void 0 : user.phone_number) != (formData === null || formData === void 0 ? void 0 : formData.phone_number) && !showVerificationModal)) {
              _context.n = 2;
              break;
            }
            setShowVerificationModal(true);
            return _context.a(2);
          case 2:
            cashCheckout3Event(formData === null || formData === void 0 ? void 0 : formData.phone_number, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.g4_data_layer);
            unbxdParams = {
              action: "cart",
              qty: "1",
              url: serverUrl + location.pathname + location.search,
              pid: post_id
            };
            unbxdAnalytics(unbxdParams);
            _context.p = 3;
            _context.n = 4;
            return fetch__createOrder();
          case 4:
            response = _context.v;
            // Type guard to check if response has validation errors (API error response)
            hasValidationErrors = function hasValidationErrors(obj) {
              return obj && obj.success === false && Array.isArray(obj.validation_errors);
            }; // Type guard to check if response has general error
            hasError = function hasError(obj) {
              return obj && obj.success === false && typeof obj.error === 'string';
            }; // Check if the response indicates success
            if (!(!response || response.success === false)) {
              _context.n = 7;
              break;
            }
            if (!hasValidationErrors(response)) {
              _context.n = 5;
              break;
            }
            backendErrors = {};
            response.validation_errors.forEach(function (errorObj) {
              Object.keys(errorObj).forEach(function (fieldName) {
                backendErrors[fieldName] = errorObj[fieldName];
              });
            });

            // Set the backend validation errors to show in the form
            setErrors(function (prev) {
              return _objectSpread(_objectSpread({}, prev), backendErrors);
            });

            // Show error toast with all validation messages
            errorMessages = Object.values(backendErrors).join(', ');
            showErrorToast(errorMessages);
            return _context.a(2);
          case 5:
            if (!hasError(response)) {
              _context.n = 6;
              break;
            }
            showErrorToast(response.error);
            return _context.a(2);
          case 6:
            // Generic error for unsuccessful response
            showErrorToast(t("error_occurred_while_creating_request", {
              ns: "web_checkout_cash"
            }));
            return _context.a(2);
          case 7:
            // Cast to expected order type for successful response
            freshOrder = response; // Only proceed if we have a valid order with an ID
            if (freshOrder !== null && freshOrder !== void 0 && freshOrder.id) {
              _context.n = 8;
              break;
            }
            showErrorToast(t("error_occurred_while_creating_request", {
              ns: "web_checkout_cash"
            }));
            return _context.a(2);
          case 8:
            setLocalStorage("otp_visited_".concat(freshOrder === null || freshOrder === void 0 ? void 0 : freshOrder.id), "0");
            submission_source = getSubmissionSource();
            promoCodedata = getPromoEventParams(!(formData !== null && formData !== void 0 && formData.code) || (promoCode === null || promoCode === void 0 ? void 0 : promoCode.code) !== (formData === null || formData === void 0 ? void 0 : formData.code));
            trackEvents("cash_form_submit", _objectSpread(_objectSpread({
              order_id: freshOrder === null || freshOrder === void 0 ? void 0 : freshOrder.id
            }, checkoutOrder.g4_data_layer), {}, {
              post_trim: checkoutOrder.g4_data_layer.post_ext,
              discount_code: (formData === null || formData === void 0 ? void 0 : formData.code) || null,
              total_amount: parseFloat(checkoutOrder.total_price.replace(/,/g, "")),
              inventory_type_string: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$g4_dat3 = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat3 === void 0 ? void 0 : _checkoutOrder$g4_dat3.inventory_type_string,
              user_city: cities.find(function (city) {
                return city.id == (formData === null || formData === void 0 ? void 0 : formData.city_id);
              }).name_en,
              referral_location: submission_source
            }, promoCodedata));
            completeCashCheckoutAbandonmentTracking();
            props.setShowOtp(true);
            _context.n = 10;
            break;
          case 9:
            _context.p = 9;
            _t = _context.v;
            if (_t instanceof ValidationException) {
              formValidationException = _t;
              setValidationException(formValidationException);
              showErrorToast(formValidationException.getAllErrorMessages());
            } else {
              // Handle any other unexpected errors
              console.error('Order creation error:', _t);
              showErrorToast(t("error_unexpected_error_occurred_try_again", {
                ns: "web_checkout_cash"
              }));
            }
          case 10:
            return _context.a(2);
        }
      }, _callee, null, [[3, 9]]);
    }));
    return function handleSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var activateTheCode = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(value) {
      var data;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _context2.n = 1;
            return fetch__getPromoCode(value);
          case 1:
            data = _context2.v;
            if (data && !data.valid) {
              setErrors(_objectSpread(_objectSpread({}, errors || {}), {}, {
                code: data.error
              }));
              setTimeout(function () {
                setErrors(_objectSpread(_objectSpread({}, errors || {}), {}, {
                  code: null
                }));
              }, 3000);
            } else {
              fetch__getOrderDetailsByParams({
                code: value
              });
            }
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function activateTheCode(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (user) {
      setFormItem("full_name", user === null || user === void 0 ? void 0 : user.full_name);
      setFormItem("phone_number", user === null || user === void 0 ? void 0 : user.phone_number);
    }
    if (hasTawuniyaParams) {
      setFormItem("referral", referral);
      setFormItem("customerid", customerid);
    }
  }, []);
  var isPromoTagVisible = checkFeatureFlag("FE_CUTOMIZED_PROMO_CODE") && displayConfig.showTag;
  useEffect(function () {
    // SE-11902: only run for an actual URL promo — promoFromUrl starts null and this
    // effect would otherwise wipe a restored/persisted code on mount.
    if (!promoFromUrl) return;
    setFormItem("code", promoFromUrl);
    // Auto-activate the code
    setTimeout(function () {
      activateTheCode(promoFromUrl);
    }, 100);
  }, [promoFromUrl]);
  useEffect(function () {
    var _checkoutOrder$discou;
    // Auto-apply promo code from URL if present, and check it if valid or not
    var urlParams = new URLSearchParams(location.search);
    var code = urlParams.get('promo');
    if (!promoFromUrl && !(formData !== null && formData !== void 0 && formData.code) && code && (isPromoTagVisible || (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$discou = checkoutOrder.discounts) === null || _checkoutOrder$discou === void 0 ? void 0 : _checkoutOrder$discou.length) > 0 && checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.discounts.find(function (discount) {
      return discount.code === code;
    }))) {
      setPromoFromUrl(urlParams.get('promo'));
    }
  }, [location.search, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.discounts]);
  useEffect(function () {
    document.title = "".concat(t("details_review", {
      ns: "web_checkout_cash"
    }), "  ").concat(checkoutOrder ? checkoutOrder.post_title : "");
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: props.style ? props.style : undefined,
    className: [stl.container, props.loading ? stl.formLoad : undefined].join(" ")
  }, props.loading && /*#__PURE__*/React.createElement("div", {
    className: ["textLoading textLoadingPage", stl.posAbs].join(" ")
  }), isMobile && /*#__PURE__*/React.createElement(MobileCarInfoV2, {
    className: "mt-5 mb-6",
    checkoutOrder: checkoutOrder,
    onClickInfoIcon: props.onClickInfoIcon
  }), isMobile && /*#__PURE__*/React.createElement("div", {
    className: "mt-5"
  }, /*#__PURE__*/React.createElement(WarrantySection, {
    checkoutOrder: checkoutOrder,
    orderType: "cash",
    referralLocation: "checkout",
    warranty_promo_code_enabled: (referralData === null || referralData === void 0 ? void 0 : referralData.type) === REFERRER_REWARD_TYPE.WARRANTY,
    onWarrantyChange: (/*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(id) {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              setFormItem("v_warranty_id", id);
              _context3.n = 1;
              return fetch__getOrderDetailsByParams({
                warranty_id: id,
                city_id: String((formData === null || formData === void 0 ? void 0 : formData.city_id) || "")
              });
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }())
  })), /*#__PURE__*/React.createElement("strong", {
    className: stl.hdr
  }, t("add_information", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CustomInput, {
    id: "checkout-fullname-input",
    name: "full_name",
    className: stl.rowData,
    label: t("full_name", {
      ns: "web_checkout_cash"
    }),
    type: "text",
    placeholder: t("full_name_2", {
      ns: "web_checkout_cash"
    }),
    error: getErrMsg("full_name"),
    handleChange: function handleChange(target) {
      var _props$setHasUserStar2;
      setHasUserStartedCheckoutForm(true);
      (_props$setHasUserStar2 = props.setHasUserStartedCheckoutForm) === null || _props$setHasUserStar2 === void 0 ? void 0 : _props$setHasUserStar2.call(props, true);
      setFormItemProxy("full_name", target.value);
    },
    onBlur: function onBlur(e) {
      validateFieldOnBlur("full_name", e.target.value);
    },
    value: formData === null || formData === void 0 ? void 0 : formData.full_name
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(InputPhoneNumber, {
    id: "checkout-phone-input",
    className: stl.rowData,
    defaultValue: formData === null || formData === void 0 ? void 0 : formData.phone_number,
    onChange: function onChange(value) {
      var _props$setHasUserStar3;
      setHasUserStartedCheckoutForm(true);
      (_props$setHasUserStar3 = props.setHasUserStartedCheckoutForm) === null || _props$setHasUserStar3 === void 0 ? void 0 : _props$setHasUserStar3.call(props, true);
      setFormItemProxy("phone_number", value);
    },
    onBlur: function onBlur() {
      validateFieldOnBlur("phone_number", formData === null || formData === void 0 ? void 0 : formData.phone_number);
    },
    errorLabel: getErrMsg("phone_number")
  }), /*#__PURE__*/React.createElement("label", {
    className: stl.whtsFlx
  }, /*#__PURE__*/React.createElement("input", {
    onChange: function onChange(target) {
      var new_value = formData !== null && formData !== void 0 && formData.whatsapp_optin ? 0 : 1;
      setFormItemProxy("whatsapp_optin", new_value);
    },
    defaultChecked: formData === null || formData === void 0 ? void 0 : formData.whatsapp_optin,
    type: "checkbox",
    name: "whatsapp_optin"
  }), /*#__PURE__*/React.createElement("span", {
    className: stl.boxDummy
  }), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/wpImg.svg",
    alt: "whts",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("span", null, t("like_communicate_receive_update_updates", {
    ns: "web_checkout_cash"
  })))), /*#__PURE__*/React.createElement(CustomInput, {
    id: "checkout-city-select",
    name: "city_id",
    className: stl.rowData,
    label: t("city", {
      ns: "web_checkout_cash"
    }),
    type: "select",
    referralData: referralData,
    handleChange: function handleChange(value) {
      var _props$setHasUserStar4, _checkoutOrder$warran, _checkoutOrder$warran2;
      setHasUserStartedCheckoutForm(true);
      (_props$setHasUserStar4 = props.setHasUserStartedCheckoutForm) === null || _props$setHasUserStar4 === void 0 ? void 0 : _props$setHasUserStar4.call(props, true);
      setFormItemProxy("city_id", Number(value));
      // Re-fetch with selected warranty preserved
      var currentWarrantyId = checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$warran = checkoutOrder.warrantyV2) === null || _checkoutOrder$warran === void 0 ? void 0 : (_checkoutOrder$warran2 = _checkoutOrder$warran.selected) === null || _checkoutOrder$warran2 === void 0 ? void 0 : _checkoutOrder$warran2.id;
      fetch__getOrderDetailsByParams(_objectSpread({
        city_id: String(value)
      }, currentWarrantyId != null && {
        warranty_id: currentWarrantyId
      }));
      var msg = t("shipping_cost_updated", {
        ns: "web_checkout_cash"
      });
      showToast(msg);
    },
    options: cities && [{
      name: t("select", {
        ns: "web_checkout_finance"
      }),
      id: ""
    }].concat(_toConsumableArray(cities)),
    selected: formData === null || formData === void 0 ? void 0 : formData.city_id,
    error: getErrMsg("city_id")
  }), /*#__PURE__*/React.createElement("p", {
    className: "".concat(stl.smallNote, " ").concat(getErrMsg("city_id") ? stl.pt10 : "")
  }, t("shipping_cost_city_added_total", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("hr", {
    className: "".concat(stl.hr, " m-hide")
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.codeContainer
  }, /*#__PURE__*/React.createElement("strong", {
    className: stl.subHdr
  }, t("discount_code", {
    ns: "web_checkout_cash"
  })), isPromoTagVisible && /*#__PURE__*/React.createElement(PromoTag, {
    tags: allPromoCodes,
    value: formData === null || formData === void 0 ? void 0 : formData.code,
    onClick: function onClick(value) {
      setFormItemProxy("code", value);
      activateTheCode(value);
    },
    withPopUp: true
  }), (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.discounts) && checkoutOrder.discounts.length > 0 && /*#__PURE__*/React.createElement(Tag, {
    selectedTag: function selectedTag(target) {
      setFormItemProxy("code", target === null || target === void 0 ? void 0 : target.code);
    },
    tags: checkoutOrder.discounts,
    value: formData === null || formData === void 0 ? void 0 : formData.code,
    onClick: function onClick(value) {
      setFormItemProxy("code", value);
      activateTheCode(value);
    },
    withPopUp: true
  }), /*#__PURE__*/React.createElement(CustomInput, {
    id: "checkout-promo-input",
    buttonId: "checkout-apply-promo-btn",
    errorId: "checkout-promo-error",
    name: "code",
    className: stl.rowData,
    label: t("discount_code_2", {
      ns: "web_checkout_cash"
    }),
    type: "text",
    placeholder: t("enter_discount_code", {
      ns: "web_checkout_cash"
    }),
    hasButton: true,
    buttonText: t("activate", {
      ns: "web_checkout_cash"
    }),
    ErrorInCode: getErrMsg("code"),
    ErrorMsg: getErrMsg("code"),
    value: formData === null || formData === void 0 ? void 0 : formData.code,
    resetCode: action__resetPromoCode,
    handleChange: function handleChange(target) {
      setFormItemProxy("code", target.value);
      if (!target.value) {
        action__resetPromoCode();
      }
    },
    buttonFunction: function buttonFunction() {
      return activateTheCode(formData === null || formData === void 0 ? void 0 : formData.code);
    },
    isValid: referralData === null || referralData === void 0 ? void 0 : referralData.valid,
    referralMsg: referralData === null || referralData === void 0 ? void 0 : referralData.title
  })), (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.post_is_new) != 1 && (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.is_warranty_10_day) && /*#__PURE__*/React.createElement(NDayGuarantee, {
    className: "m-show",
    img: CDN_LINK + "/assets/images/dm10.svg"
  }), (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.post_is_new) == 1 && /*#__PURE__*/React.createElement("p", {
    className: [stl.smallNote, stl.noteBtm].join(" ")
  }, /*#__PURE__*/React.createElement("strong", null, t("notice", {
    ns: "web_checkout_cash"
  })), t("paying_down_payment_reserve_car", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("p", {
    className: [stl.smallNote, stl.noteBtm].join(" ")
  }, !(checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.post_is_new) && t("down_payment_fully_refundable_registration_2", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.contBtnContainer
  }, /*#__PURE__*/React.createElement("button", {
    id: "checkout-submit-btn",
    type: "submit",
    className: "greenBtn",
    disabled: buttonLoading
  }, /*#__PURE__*/React.createElement("strong", null, t("continue_down_payment", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", null, checkoutOrder && checkoutOrder.arboun, /*#__PURE__*/React.createElement("span", {
    className: "text-lg"
  }, t("sar", {
    ns: "web_checkout_cash"
  }))))))), /*#__PURE__*/React.createElement(ChangeAccountVerificationModal, {
    show: showVerificationModal,
    onClose: function onClose() {
      return setShowVerificationModal(false);
    },
    onSubmit: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            setShowVerificationModal(false);
            _context4.n = 1;
            return logout(null);
          case 1:
            handleSubmit();
          case 2:
            return _context4.a(2);
        }
      }, _callee4);
    })),
    newPhoneNumber: formData === null || formData === void 0 ? void 0 : formData.phone_number,
    loading: buttonLoading
  }));
};
export default ShopApplyForm;